import * as React from 'react';
import StringWidget from 'components/StringWidget';
import { isEmpty } from 'lodash';
import cx from 'classnames';
import styles from './CartItem.css';
import { numFormat } from 'utils/numFormat';
export const PickupCharge = props => {
    const { pricingInfo, className } = props;
    // The pickupcharge < 0 check is a bit wrong, considering we try to convert
    // the value using the `Number` call.
    if (isEmpty(pricingInfo) || !pricingInfo.pickUpCharge || pricingInfo.pickUpCharge < 0) {
        return null;
    }
    const { pickUpCharge } = pricingInfo;
    return (<StringWidget strKey="cartPickupCharge" className={cx(styles['pickup-charge'], className)} attributes={{ pickupCharge: `₹${numFormat(Number(pickUpCharge))}` }}/>);
};
